export { LaboratoryResouceConfig } from './src/const';
export { LaboratoryResourceService } from './src/resource.service';
export { provideLaboratoryResouceConfig } from './src/helpers';
